import {createReducer, on} from '@ngrx/store';
import {OauthMeUser} from '../../data/model';
import * as currentUserActions from './current-user.actions';

export interface CurrentUserState {
  user: OauthMeUser | undefined;
}

export const initialState: CurrentUserState = {
  user: undefined,
};

export const reducer = createReducer(
  initialState,
  on(currentUserActions.loadCurrentUserSuccess, (state, {user}) => ({
    ...state,
    user,
  })),
  on(currentUserActions.loadCurrentUserFailure, state => ({
    ...state,
    user: undefined,
  })),
  on(currentUserActions.loadCurrentUser, state => state),
);

export const currentUser = (state: CurrentUserState): OauthMeUser | undefined =>
  state.user;
